export default "__VITE_ASSET__26fsH48z__"